import b from "./index55.js";
import s from "./index60.js";
import l from "./index49.js";
const m = (r, t) => {
  if (r = r ? r.filter(Boolean) : [], !t && !r.length)
    return;
  const u = new AbortController();
  let f = !1;
  const n = function(e) {
    if (!f) {
      f = !0, i();
      const o = e instanceof Error ? e : this.reason;
      u.abort(
        o instanceof s ? o : new b(o instanceof Error ? o.message : o)
      );
    }
  };
  let c = t && setTimeout(() => {
    c = null, n(new s(`timeout of ${t}ms exceeded`, s.ETIMEDOUT));
  }, t);
  const i = () => {
    r && (c && clearTimeout(c), c = null, r.forEach((e) => {
      e.unsubscribe ? e.unsubscribe(n) : e.removeEventListener("abort", n);
    }), r = null);
  };
  r.forEach((e) => e.addEventListener("abort", n, { once: !0 }));
  const { signal: a } = u;
  return a.unsubscribe = () => l.asap(i), a;
}, h = m;
export {
  h as default
};
